import React from "react";
import {
  Edit,
  SimpleForm,
  Toolbar,
  SaveButton,
  NumberInput,
  DisabledInput
} from "react-admin";

const CustomToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export default props => (
  <Edit {...props}>
    <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
      <DisabledInput source="id" label="Code" />
      <DisabledInput source="Name" label="Name"/>
      <NumberInput source="Points" />
    </SimpleForm>
  </Edit>
);
